import React, { useState, useRef } from 'react';

import {
  ProductPage,
  ProductContainer,
  ProductHeader,
  SwipeContent,
  SlideText,
  SlideImage,
} from './ProductSectionElements';

import { Models } from './Data';
import { LibraryModel } from '../../Library/LibraryModel';
import { Swiper, SwiperSlide, Navigation, Autoplay, EffectCoverflow } from '../../shared/Swiper';
import { useLanguage } from '../../../hooks';

import './ProductStyle.css';
import { CustomPagination } from '../../shared/CustomPagination/index';

const ProductSection = () => {
  const { lang } = useLanguage();
  const swiperRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const extendedModels = [
    ...Models.map((m) => ({ ...m, uniqueKey: `${m.image}_1` })),
    ...Models.map((m) => ({ ...m, uniqueKey: `${m.image}_2` })),
    ...Models.map((m) => ({ ...m, uniqueKey: `${m.image}_3` })),
  ];

  const handleDotClick = (index) => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideTo(index + Models.length);
    }
  };

  return (
    <ProductPage id="product">
      <ProductContainer>
        <ProductHeader>{LibraryModel[lang]?.lineup}</ProductHeader>

        <Swiper
          ref={swiperRef}
          effect={'coverflow'}
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={'auto'}
          loop={true}
          loopAdditionalSlides={2}
          navigation={true}
          speed={800}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          coverflowEffect={{
            rotate: 30,
            stretch: 0,
            depth: 0,
            modifier: 1,
            slideShadows: false,
          }}
          pagination={false}
          onSlideChange={(swiper) => {
            setActiveIndex(swiper.realIndex % Models.length);
          }}
          modules={[EffectCoverflow, Autoplay, Navigation]}
          className="mySwiper"
        >
          {extendedModels.map((model) => (
            <SwiperSlide key={model.uniqueKey}>
              <div className="slide-inner">
                <SwipeContent to={model.link}>
                  <SlideImage src={model.image} />
                  <SlideText>
                    {LibraryModel[lang] ? LibraryModel[lang]['headerText' + model.id] : ''}
                  </SlideText>
                </SwipeContent>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <CustomPagination
          totalItems={Models.length}
          activeIndex={activeIndex}
          onDotClick={handleDotClick}
        />
      </ProductContainer>
    </ProductPage>
  );
};

export default ProductSection;
